import React from 'react';
import type { Link } from '@helpcenter/analytics-components';
import type { HtmlAnchor } from '@helpcenter/analytics-components/src/html-anchor';
import { HELP_CENTERS_MANAGEMENT_BASE_PATH } from '@helpcenter/constants';
import { getHelpCenterAri } from '@helpcenter/meta';
import { FormattedMessage, useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { CustomItem } from '@atlaskit/menu';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import messages from './messages';

interface RovoAgentMenuProps {
	onClose: (actionSubjectId?: string) => void;
	component: typeof Link | typeof HtmlAnchor;
}

export const RovoAgentMenu = ({ onClose, component }: RovoAgentMenuProps) => {
	di(getHelpCenterAri);
	const { formatMessage } = useIntl();
	const { helpCenterId } = HelpHelpCenterAri.parse(getHelpCenterAri());

	const handleClick = () => onClose('navBarRovoAgent');

	return (
		<CustomItem
			key="customize-menu_navBarRovoAgent"
			component={component}
			href={`${HELP_CENTERS_MANAGEMENT_BASE_PATH}/${helpCenterId}/rovo-agent`}
			actionSubjectId="navBarRovoAgent"
			onClick={handleClick}
			testId="rovo-agent-link"
			iconAfter={<Lozenge appearance="discovery">{formatMessage(messages.newLozenge)}</Lozenge>}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
			className="cv-exclude-from-customisation"
		>
			<FormattedMessage {...messages.rovoAgent} />
		</CustomItem>
	);
};
